<template>
  <div></div>
</template>

<script>
import { setAuth, logout } from "@/utils/auth";
export default {
  components: {},
  created() {
    logout();
  }
};
</script>
